export default __webpack_public_path__ + "32aa1f99a73d4b05dd096d48f07c76d8.svg";